
import FooterTopFormNewsletter from '@/components/FooterTopFormNewsletter'

export default {
  name: 'ModalSubscriptionNewsletter',
  components: { FooterTopFormNewsletter },
  computed: {
    advantages() {
      return [
        'components.modalSubscriptionNewsletter.advantageNewProductsPreview',
        'components.modalSubscriptionNewsletter.advantagePersonalizedAdvice',
        !this.$store.getters.is_pro_plus &&
          'components.modalSubscriptionNewsletter.advantageVehicleOffers',
        'components.modalSubscriptionNewsletter.advantageSubscriberOffers',
        'components.modalSubscriptionNewsletter.advantageNewsletterFrequency',
      ].filter(Boolean)
    },
  },
  watch: {
    '$route.path'() {
      this.$bvModal.hide('ModalSubscriptionNewsletter')
    },
  },
  methods: {
    async loadLottieGift() {
      if (!process.client) return

      const lottie = await import('lottie-web')

      setTimeout(() => {
        lottie.default
          .loadAnimation({
            container: document.getElementById('lottieGift'),
            renderer: 'svg',
            loop: false,
            autoplay: true,
            path: '/lotties/gift.json',
          })
          .setSpeed(0.7)
      }, 300)
    },
  },
}
